import { ControlAttributeType, } from "../../../../form/typings";
import { formatterValueToSetStatus, formatterRequiredFormula, } from "../../../../form/utils";
import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { FormControlType } from "../../../../form/schema";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: ["displayEnd", "dataLinkage"],
        },
        scripts: {
            label: "控件事件",
            keys: ["onUpload", "onDelete"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: {
            inputMethod: ControlAttributeType.Dropdown,
            value: FormControlType.Signature,
            options: {
                // Todo 将控件编码 换成 说明文字, 创建所有组件的 编码说明文件
                list: [
                    {
                        value: FormControlType.Attachment,
                        label: i18n.t('dataitem.Attachment').toString(),
                    },
                    {
                        value: FormControlType.Image,
                        label: i18n.t('dataitem.Image').toString(),
                    },
                    {
                        value: FormControlType.Signature,
                        label: i18n.t('dataitem.Signature').toString(),
                    },
                ],
            },
        },
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.Attachment').toString() }),
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/data-linkage2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        displayEnd: {
            options: {
                disabled: true,
            },
        },
        onUpload: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/script-input.vue"),
        },
        onDelete: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/script-input.vue"),
        },
    },
};
